import { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import useAnimatedTransition from "./useAnimatedTransition";

const assignRef = (ref, element) => {
  if (!ref) {
    return;
  }

  if (typeof ref === "function") {
    ref(element);

    return;
  }

  ref.current = element;
};

const AnimatedList = ({ children, disableAnimation = false }) => {
  const childRefs = useAnimatedTransition({
    reactElements: children,
    disableAnimation
  });

  return (
    <ol>
      {Children.map(children, child =>
        cloneElement(child, {
          ref: element => {
            childRefs.current[child.key] = element;
            assignRef(child.ref, element);
          }
        })
      )}
    </ol>
  );
};

AnimatedList.propTypes = {
  children: PropTypes.node.isRequired,
  disableAnimation: PropTypes.bool
};

export default AnimatedList;
